export const defaultAvatar = 'https://firebasestorage.googleapis.com/v0/b/chat-app-3ddc7.appspot.com/o/avatar.svg?alt=media&token=f22c3cb8-ad9e-4d2c-8798-b135266a7371';
